
import ajax from './index'
import apiEnv from './apiEnv'

// 获取后台用户列表
export function getAdminUser(data) {
    return ajax.post(`${apiEnv.api4}/api/Common/GetAdminUser`, data)
}
// 获取动态预警统计数据
export function getDynamicWarningData(data) {
    return ajax.post(`${apiEnv.api4}/api/SalesStatistics/GetDynamicWarningData`, data)
}
// 添加统计数据
export function addFunctionStatistics(data) {
    return ajax.post(`${apiEnv.api4}/api/SalesStatistics/AddFunctionStatistics`, data)
} 
// 获取edi工单列表
export function getEdiJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/Edi/GetEdiJobList`, data)
}
 // 保存edi配置
export function saveEdiJobConfig(data) {
    return ajax.post(`${apiEnv.api4}/api/Edi/SaveEdiJobConfig`, data)
} 
// 获取zyd客户工单列表
export function getZydKaJobList(data) {
    return ajax.post(`${apiEnv.api4}/api/Edi/GetZydKaJobList`, data)
}